// @ts-nocheck
import Two from "two.js";
import { colorShape, posV, speedV, clamp, Interpolator, chebyshevPolys, EntityMotion, timeScale, angleCache, bitmask, parseSpriteCode } from "./Utility";
import { Point, lerp, anglerp } from "./Utility";
import { playerMaxHP, playerSpeed } from "../common/Config";
import { ENDPOINT } from "./Application";
import * as math from 'mathjs'
import { getStateCallbacks } from "colyseus.js";
// import * as bootstrap from 'bootstrap'

const R = Two.Rectangle
const Po = Two.Path
const An = Two.Anchor
const C = Two.Circle
const G = Two.Group

const startingZ = 3;

export class Viewport extends Two{
    aspect: number
    baseW: number
    baseH: number
    timer;
    zGroups: Two.Group[];
    constructor(baseW, baseH){
        super({width: baseW, height: baseH})
        this.setBase(baseW, baseH)
        this.zGroups = [...Array(startingZ)].map(() => new Two.Group())
        this.zGroups.forEach((e) => {super.add(e)})
    }

    setBase(baseW, baseH){
        this.baseW = baseW
        this.baseH = baseH
        this.aspect = this.baseH / this.baseW
        this.scene.scale = this.renderer.width / this.baseW
        this.resize()
    }

    resize(){
        var elem = this.renderer.domElement.parentElement 
        if (elem){
            var {width: elemW, height: elemH} = elem.getBoundingClientRect()
            this.renderer.setSize(Math.min(elemW, elemH / this.aspect), Math.min(elemH, elemW * this.aspect))
            this.scene.scale = this.renderer.width / this.baseW
        }
    }

    toLocal(x, y){
        return {x: x / this.scene.scale, y: y / this.scene.scale}
    }

    appendTo(elem: HTMLElement) {
        var temp = super.appendTo(elem)
        this.resize()
        return temp
    }

    add(e, z=0){
        if (z >= this.zGroups.length){
            var g = new Two.Group()
            super.add(g)
            this.zGroups.push(g)
        }
        this.zGroups[z].add(e)
    }
    remove(e){
        this.zGroups.forEach((g) => {
            g.remove(e)
        })
        super.remove(e)
    }

}

class GraphicsMap{
    graphics = {}
    default = new G([colorShape(new C(0, 0, 5))])
    addGraphics(name, graphics){
        this.graphics[name] = graphics
    }
    getGraphics(name){
        if (name[0] == '!'){
            return parseSpriteCode(name)
        }
        console.log(this.graphics[name])
        return (this.graphics[name] ?? this.default)?.clone()
    }
}
const graphicsMap = new GraphicsMap()

export async function fetchGraphics(viewport){
    let response = await fetch(ENDPOINT + '/sprites')
    if (response.ok){
        let graphicsReg = await response.json()
        for (var k of graphicsReg['sprites']){
            let _k = k
            console.log(k)
            await viewport.load(ENDPOINT + '/' + k, (obj) => {
                obj.translation.x -= obj.children[0].width / 2
                obj.translation.y -= obj.children[0].height / 2
                graphicsMap.addGraphics(_k, new G([obj]))
            })
        }
    }
}

export function getRenderer(entity, ...args){
    switch (entity.entityType){
        case "player":
            return new PlayerRenderer(entity, ...args);
        case "wall":
            return new WallRenderer(entity, ...args);
        default:
            return new InterpolatedGroup(entity, ...args);
    }
}

class BoundingBox{
    left: number
    right: number
    top: number
    bottom: number

    checkPoint(x, y){
        return (x >= left) && (x <= right) && (y >= bottom) && (y <= top)
    }

    overlap(other){
        var leftest = this.left < other.left ? this : other
        var toppest = this.top < other.top ? this : other
        return (leftest.right > (leftest.left ^ this.left ^ other.left)) && (toppest.bottom > (toppest.top ^ this.top ^ other.top))
    }

    static fromRect(r){
        return Object.assign(new BoundingBox(), r)
    }
}

const lerpCount = 10
export const offsetTime = 100 //ms
export class InterpolatedGroup extends Two.Group{
    entity: object
    lastEntityUpdate: number = 0
    
    interpolator: Interpolator;

    renderedObj;
    entityObs;
    state;
    debugVis = false;
    pastUpdates: EntityMotion[] = [];
    currentMotion: EntityMotion

    offset = offsetTime
    avgLatency = 0
    opacityCallback;
    estServerTime: number;

    checkExtrap: boolean = false
    lerpCounter: number = 0
    shapes = []

    app;

    constructor(entity, state, app){
        super()
        this.entity = entity       
        this.app = globalThis.app 
        this.add(graphicsMap.getGraphics(this.entity.sprite))
        
        this.entityObs = new Two.Group([colorShape(new C(0, 0, 10), '#0000', 'red'), colorShape(new C(0, 0, 15), '#0000', 'blue')])
        this.entityObs.opacity = 0.
        this.state = state

        this.currentMotion = EntityMotion.fromEntity(this.entity, this.state.time);
        this.pastUpdates.push(this.currentMotion);
        
        ({x: this.translation.x, y: this.translation.y} = this.currentMotion)
        this.rotation = this.entity.angle;
        this.interpolator = new Interpolator(chebyshevPolys.slice(0, 4), 0.01);
        this.avgLatency = this.state.time - Date.now() + this.app.latency
        // this.estServerTime = Date.now() - this.offset + this.avgLatency

        this.shapes = [this, this.entityObs]
        this.interpolator.interpolateMotion(this.currentMotion, this.currentMotion)
    }

    updateEntity(){
        let recvTime = Date.now()
        let stateTime = this.state.time

        if (this.pastUpdates.length == 1){
            this.checkExtrap = true
        }
        if (this.pastUpdates.length > 0 && (this.pastUpdates[this.pastUpdates.length-1].serverTime > this.state.time)){
            this.pastUpdates[this.pastUpdates.length - 1].serverTime = this.state.time - offsetTime
        }
        this.pastUpdates.push(EntityMotion.fromEntity(this.entity, this.state.time))
        if ((Date.now() - this.lastEntityUpdate) > 1000){
            this.app.ping()
            this.app.onLatencyUpdate = () => {
                console.log('PING', this.app.latency)
                this.avgLatency = 0.95 * this.avgLatency + 0.05 * (stateTime + this.app.latency - recvTime)
                console.log('SKEW', this.avgLatency)
                this.app.onLatencyUpdate = () => {}
            }
            this.lastEntityUpdate = Date.now()
        }

    }

    get estServerTime(){
        return Date.now() - this.offset + this.avgLatency
    }

    update(dt){
        let E = this.entity
        var estServerTime = this.estServerTime

        while (this.pastUpdates.length >= 2 && estServerTime >= this.pastUpdates[1].serverTime){
            this.pastUpdates.shift()
        }
        // if (this.checkExtrap && (this.lerpCounter == 0)){
        //     console.log('TRANSITION')
        //     this.checkExtrap = false
        //     this.lerpCounter = lerpCount
        // }

        var first = this.pastUpdates[0]
        var second = this.pastUpdates[Math.min(this.pastUpdates.length - 1, 1)]
        this.interpolator.interpolateMotion(first, second);
        
        var obs = [first, second];
        this.entityObs.children.forEach((e, i) => {e.translation.x = obs[i].x; e.translation.y = obs[i].y})
        
        var [[newX, newY]] = this.interpolator.eval(estServerTime, 1).valueOf();
        var T = this.interpolator.toT.bind(this.interpolator)
        if ((T(estServerTime) > T(second.serverTime) + this.interpolator.exLim) || (second.speed == 0)){
            second.serverTime = estServerTime
            second.x = newX
            second.y = newY
            second.speed = 0
        }

        if ((this.lerpCounter--) > 0){
            console.log('LERPING')
            this.translation.x = lerp(this.translation.x, newX, 1 - this.lerpCounter/(lerpCount + 1))
            this.translation.y = lerp(this.translation.y, newY, 1 - this.lerpCounter/(lerpCount + 1))
        }
        else{
            this.translation.x = newX
            this.translation.y = newY
        }

        this.rotation = anglerp(this.rotation, E.angle || 0, 0.1)
        this.scale = lerp(this.scale, E.scale || 1, 0.1)
    }

    checkCollision(){
        var curB = BoundingBox.fromRect(this.getBoundingClientRect())
        for (var group of this.app.viewport.zGroups){
            for (var child of group.children){
                if (this.shapes.includes(child) || !child.entity){
                    continue
                }
                var bbox = BoundingBox.fromRect(child.getBoundingClientRect())
                if (curB.overlap(bbox)){
                    // console.log(curB, bbox, child.entity.entityType)
                    return true
                }
            }
        }
        return false
    }

    addToView(viewport){
        viewport.add(this.shapes, this.entity.z ?? 0)
    }
    removeFromView(viewport){
        var opacityCallback = (() => {
            if (this.opacity < 5/offsetTime){
                viewport.remove(this.shapes)
                clearInterval(this.opacityCallback)
            }
            else{
                this.opacity -= 5/offsetTime
                viewport.update()
            }
            
        }).bind(this)
        clearInterval(this.opacityCallback)
        this.opacityCallback = setInterval(opacityCallback, 10)
    }
}

export class CenteredGroup extends Two.Group{
    elemDict = {}
    innerGroup: Two.Group = new Two.Group()
    constructor(){
        super()
        super.add(this.innerGroup)
    }

    add(e, n?){
        console.log('ADDING ELEM', e)
        this.elemDict[n ?? ''] = e
        this.innerGroup.add(e)
        this.innerGroup.center()
    }
    remove(n){
        this.innerGroup.remove(this.elemDict[n])
        delete this.elemDict[n]
    }
}

export class PlayerRenderer extends InterpolatedGroup{
    hpBar: Two.Path
    hpBase: Two.Path
    hpGroup: Two.Group
    effectGroup: CenteredGroup
    usernameGroup: CenteredGroup

    inactiveDisplay: Two.Group
    lastDt;
    debug;
    timeOver = 0;
    offset: number = 0;

    constructor(entity, state, app){
        super(entity, state, app)
        this.debug = colorShape(new C(0, 0, 15), "#0000", "purple")
        this.debug.opacity = 0.

        this.hpBase = colorShape(new R(0, 15, 20, 5), "gray", "gray")
        this.hpBar = colorShape(new R(0, 15, 20, 5), "red", "red")

        this.inactiveDisplay = colorShape(new C(0, 0, 20), "lightblue", "blue")
        this.inactiveDisplay.scale = 0
        this.inactiveDisplay.opacity = 0.5

        this.hpGroup = new G([this.hpBase, this.hpBar])

        this.effectGroup = new CenteredGroup();
        var {left: left, right: right, top:top, bottom: bottom} = this.getBoundingClientRect(true)
        var {x: x, y: y} = this.translation

        var clearance = Math.max(Math.abs(x - left), Math.abs(x - right), Math.abs(y - top), Math.abs(y - bottom))
        
        this.usernameGroup = new CenteredGroup();
        this.usernameGroup.innerGroup.translation.y = -clearance
        this.effectGroup.innerGroup.translation.y = 23

        this.shapes = [...this.shapes, this.hpGroup, this.debug, this.inactiveDisplay, this.effectGroup, this.usernameGroup]
        // this.estServerTime = this.state.time + 10

        const $ = getStateCallbacks(this.app.room);
        $(this.entity).effects.onAdd((e) => {
            this.effectGroup.add(graphicsMap.getGraphics(e.icon), e.effectName)
        })

        $(this.entity).effects.onRemove((e) => {
            this.effectGroup.remove(e.effectName)
        })
    }

    updateEntity(): void {
        super.updateEntity();
    }

    update(dt){
        // let clientTime = performance.now() + performance.timeOrigin
        if (!dt){
            return
        }
        // dt = (this.lastDt ?? dt)*0.75 + 0.25*dt
        // this.lastDt = dt
        
        var df = dt * 60 / 1000
        var bmask = 0

        this.app.heldKeys.forEach((e) => {
            bmask |= bitmask[e]
        })
        var ang = angleCache[bmask]
        var speed = bmask ? this.entity.maxSpeed : 0
        var [speedX, speedY] = [Math.cos(ang) * speed, Math.sin(ang) * speed]
        var [estX, estY] = [this.translation.x + df * speedX, this.translation.y + df * speedY];
        super.update(dt);
        if ((this.entity.entityID == globalThis.app.room.sessionId) && (!this.entity.inactive)){
            this.debug.translation.x = this.translation.x
            this.debug.translation.y = this.translation.y
    
            var [extrapX, extrapY] = [this.translation.x, this.translation.y];
            var dist = Math.hypot(extrapX - estX, extrapY - estY)
            this.translation.x = estX;
            this.translation.y = estY;
    
            // if (dist > 0){
            var rubberband = (this.checkCollision() || (speed == 0))
            
            if (((dist > 10) && rubberband) || (dist > 30)){
                this.timeOver += dt
            }
            else{
                this.timeOver = 0
            }
            var tlim = this.checkCollision() ? 30 : 50
            if (this.timeOver > tlim){
                this.translation.x = lerp(this.translation.x, extrapX, Math.min(1, Math.max(0, this.timeOver - tlim)/1000))
                this.translation.y = lerp(this.translation.y, extrapY, Math.min(1, Math.max(0, this.timeOver - tlim)/1000))
            }        
        }
        
        this.hpBar.scale = new Two.Vector(Math.max(0, this.entity.hp) / this.entity.maxHP, 1)
        this.hpGroup.translation = this.translation
        this.inactiveDisplay.translation = this.translation
        // console.log('INACTIVE', this.entity.inactive)
        this.inactiveDisplay.scale = this.entity.inactive ? 1 : 0
        this.effectGroup.translation = this.translation
        this.usernameGroup.translation.x = this.translation.x
        this.usernameGroup.translation.y = this.translation.y
    }

}

export class WallRenderer extends InterpolatedGroup{
    entity: object
    drawn: boolean = false
    constructor(entity, state){
        super(entity, state)
        this.remove(this.children[0])
        this.entity = entity
    }
    addToView(viewport){
        viewport.add(this)
    }
    update(dt){
        var {lx: lx, ly: ly, w: w, h: h} = this.entity
        if (!this.drawn && w && h){
            console.log('STATS', lx, ly, w, h)
            this.add(colorShape(new R(lx + w/2, ly + h/2, w, h), 'gray', 'gray'))
            this.translation.x = 0
            this.translation.y = 0
            this.drawn = true
        }
    }
}

export class GenericModal{
    constructor(modalElem, app, obj){
        this.modal = new bootstrap.Modal(modalElem, obj);
        this.modalElem = modalElem;
        this.app = app
        
        modalElem.addEventListener('hide.bs.modal', () => {
            console.log('UNSHIFT')
            // console.log(this.app.modalQueue)
            this.app.modalQueue.shift()
            // console.log(this.app.modalQueue)
            if (this.app.modalQueue.length > 0){
                this.app.modalQueue[0].modal.show()
            }
            this.app.disable = false
        })

        modalElem.addEventListener('show.bs.modal', () => {
            this.app.disable = true
            this.app.heldKeys.clear()
        })
    }
    
    onHide(callback){
        this.modalElem.addEventListener('hide.bs.modal', () => {
            callback()
        })
    }

    onShow(callback){
        this.modalElem.addEventListener('show.bs.modal', () => {
            callback()
        })
    }
    show(){
        this.app.modalQueue.push(this)
        if (this.app.modalQueue[0] == this){
            this.modal.show()
        }
    }

    hide(){
        this.modal.hide()
    }
}

export class ChoiceModal extends GenericModal{
    buttonCallback;
    constructor(modalElem, app){
        super(modalElem, app);
    }

    createCard(i){
        var card = document.createElement('div')
        card.classList.add('col-md-4')
        card.innerHTML = `
        <div class="card h-100 clickable-card" id="card${i}">
            <div class="card-header d-flex align-items-end justify-content-center" style="padding: 12px 16px; min-height: 48px;">
                <h5 class="card-title mb-0">Card 1</h5>
            </div>
            <div class="card-body d-flex flex-column">
                <p class="card-text">Some content for card 1.</p>
            </div>
        </div>`   
        // card.querySelector('button').addEventListener('click', () => {
        card.addEventListener('click', () => {
            this.buttonCallback(i)
            this.hide()
        })
        this.modalElem.querySelector('#cards .row').append(card)
        return card.children[0]    
    }

    setChoices(objs){
        var cards = this.modalElem.getElementsByClassName("card")
        
        objs.forEach((obj, i) => {
            var card = i < cards.length ? cards[i] : this.createCard(i)
            card.getElementsByClassName("card-title")[0].innerText = obj?.title
            card.getElementsByClassName("card-text")[0].innerText = obj?.desc
        })
    }
}

export class UsernameModal extends GenericModal{
    submitCallback
    constructor(...args){
        super(...args)
        this.modalElem.addEventListener('keydown', (e) => {
            if (e.key == "Enter"){
                this.submitCallback(this.modalElem.querySelector('#usernameInput').value)
                this.hide()
            }
        })
    }
}